module.exports = __webpack_public_path__ + "img/toni.e427c48e.svg";